<template>
  <generic-modal
    size
    :title="$t('transaction')"
    icon="receipt"
    image="/images/icons/receipt.png"
    v-on:destroy="destroy"
    :on_finished="finished"
  >
    <div class="description">
      <div class="ui form" ref="form">
        <div class="two fields">
          <div class="field">
            <label for>{{ $t("account finder") }}</label>
            <div class="ui blue search" ref="account_search">
              <div class="ui icon input">
                <input
                  class="prompt"
                  type="text"
                  name="account"
                  v-model="account.number"
                  :placeholder="$t('search account')"
                />
                <i class="search icon"></i>
              </div>
              <div class="results"></div>
            </div>
            <div class="two fields">
              <div class="field" style="margin-top:15px">
                <label for>{{ $t("transaction type") }}</label>
                <div class="ui search selection dropdown" ref="types_dropdown">
                  <input type="hidden" name="type" />
                  <i class="dropdown icon"></i>
                  <div class="default text"></div>
                  <div class="menu"></div>
                </div>
              </div>
              <div class="field" style="margin-top:15px">
                <label for>{{ $t("amount") }}</label>
                <input type="text" name="amount" v-model="amount" />
              </div>
            </div>
          </div>
          <div class="field">
            <div class="ui horizontal cards" v-if="account">
              <div class="card">
                <div class="image">
                  <img src="/images/icons/matthew.png" />
                </div>
                <div class="content">
                  <div class="header">{{ account.name }}</div>
                  <div class="meta">
                    <a>{{ account.number }}</a>
                  </div>
                  <div class="description">
                    <!-- <pre>{{ student }}</pre> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="
            selected_transaction_type &&
              selected_transaction_type.setup &&
              selected_transaction_type.setup.receipt &&
              selected_transaction_type.setup.receipt.ask_number
          "
        >
          <h4 class="ui icon dividing header">{{ $t("receipt") }}</h4>
          <div class="three fields">
            <div
              class="field"
              v-if="
                selected_transaction_type &&
                  selected_transaction_type.setup &&
                  selected_transaction_type.setup.receipt &&
                  selected_transaction_type.setup.receipt.ask_number
              "
            >
              <label for>{{ $t("number") }}</label>
              <input
                type="text"
                name="receipt_number"
                v-model="receipt.number"
              />
            </div>
            <div
              class="field"
              v-if="
                selected_transaction_type &&
                  selected_transaction_type.setup &&
                  selected_transaction_type.setup.receipt &&
                  selected_transaction_type.setup.receipt.ask_date
              "
            >
              <label for>{{ $t("date") }}</label>
              <div class="ui calendar" ref="receipt_date">
                <div class="ui input left icon">
                  <i class="calendar icon"></i>
                  <input type="text" :placeholder="$t('receipt date')" />
                </div>
              </div>
            </div>
            <div
              class="field"
              v-if="
                selected_transaction_type &&
                  selected_transaction_type.setup &&
                  selected_transaction_type.setup.receipt &&
                  selected_transaction_type.setup.receipt.ask_image
              "
            >
              <label for>{{ $t("image") }}</label>
              <file-pond
                name="file"
                ref="pond"
                :label-idle="$t('click or drop files here')"
                v-bind:allow-multiple="true"
                v-bind:allow-revert="false"
                v-bind:server="{
                  url: api_host,
                  timeout: enterprise_setup.upload_timeout,
                  process: {
                    url: '/account_transaction/do-upload-receipt',
                    method: 'POST',
                    headers: {
                      'x-access-token': token_session,
                    },
                    withCredentials: false,
                  },
                }"
                v-on:error="filepond_error"
                v-on:processfile="filepond_process"
              />
            </div>
          </div>
        </div>
        <div class="ui message error"></div>
        <div class="ui segment container" v-if="show_pending">
          <a class="ui red ribbon label" v-if="pending_payment_sum != amount"
            ><i class="triangle exclamation sign icon"></i
            >{{ $t("check transaction amount") }}</a
          >
          <h4 class="ui header">{{ $t("pending account movements") }}</h4>
          <table
            class="ui very compact selectable celled striped table"
            ref="pending_movements_table"
            style="width:100%"
          >
            <thead>
              <tr>
                <th>{{ $t("type") }}</th>
                <th>{{ $t("date") }}</th>
                <th>{{ $t("amount") }}</th>
                <th>{{ $t("pay") }}</th>
              </tr>
            </thead>
            <tbody></tbody>
          </table>
          <div class="ui mini horizontal statistic">
            <div class="value">
              {{
                pending_payment_sum
                  | formatCurrency(enterprise_setup.currency_iso)
              }}
            </div>
            <div class="label">
              {{ $t("paying pending sumatory") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import {
  local_api,
  stringify,
  init_search,
  api_host,
  init_json_local_data_datables,
  enterprise_setup,
} from "@/utils";
import GenericModal from "@/components/GenericModal";
import filters from "@/filters";
import { v4 } from "uuid";
import "filepond/dist/filepond.min.css";
import vueFilePond from "vue-filepond";
const FilePond = vueFilePond();

export default {
  name: "TransactionModal",
  filters: filters,
  components: {
    "generic-modal": GenericModal,
    FilePond,
  },
  props: {
    account_in: Object,
  },
  computed: {
    token_session() {
      let token = this.$session.get("token");
      return token;
    },
    pending_payment_sum() {
      let py = this.pending_movements.filter((p) => p.pay > 0);
      return py.reduce((prev, curr) => {
        return prev + Number(curr.pay);
      }, 0);
    },
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  data() {
    return {
      account: {},
      transaction_types: [],
      transactions: [],
      transaction_type: "",
      selected_transaction_type: undefined,
      amount: 0,
      receipt: {
        number: "",
        date: "",
        image: "",
      },
      api_host: api_host,
      show_pending: false,
      pending_movements: [],
    };
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    finished() {
      window.jQuery(this.$refs.form).form("validate form");
      let isValid = window.jQuery(this.$refs.form).form("is valid");
      let vm = this;
      return new Promise((resolve, reject) => {
        if (vm.show_pending && vm.pending_payment_sum != vm.amount) {
          window
            .jQuery(this.$refs.form)
            .form("add errors", [vm.$t("check transaction amount")]);
          reject();
        } else {
          if (isValid) {
            local_api(vm, "post", "/account_transaction/do-create", {
              a: vm.account.uuid,
              t: vm.transaction_type,
              m: vm.amount,
              s: JSON.stringify({
                receipt: vm.receipt,
              }),
              p: vm.show_pending
                ? vm.pending_movements
                    .filter((p) => p.pay > 0)
                    .map((p) => {
                      return { uuid: p.uuid, pay: p.pay };
                    })
                : [],
              options: {
                unique_receipt:
                  vm.selected_transaction_type &&
                  vm.selected_transaction_type.setup &&
                  vm.selected_transaction_type.setup.receipt
                    ? vm.selected_transaction_type.setup.receipt
                        .is_unique_number
                    : false,
              },
            })
              .then((response) => {
                vm.$emit("succedded", response);
                resolve(response);
              })
              .catch((err) => {
                window.jQuery(this.$refs.form).form("add errors", [err]);
                reject(err);
              });
          } else {
            reject();
          }
        }
      });
    },
    remove(transaction, index) {
      this.transactions.splice(index, 1);
    },
    filepond_error(a, b) {
      console.log("error", a, b);
    },
    filepond_process(event, inst) {
      // let x1 = this.$refs.pond;
      // console.log(x1, inst);
      if (inst.serverId) {
        let r = JSON.parse(inst.serverId);
        if (!r.success) this.$alertify.error(r.error);
        else
          this.receipt.image = {
            file_id: v4(),
            server_file: r.data,
            filename: inst.filename,
            filenameWithoutExtension: inst.filenameWithoutExtension,
            fileExtension: inst.fileExtension,
            fileType: inst.fileType,
            fileSize: inst.fileSize,
          };

        // x1.removeFiles().then((r) => {
        //   console.log(r);
        // });
      }
    },
    refreshPendingMovements() {
      let vm = this;
      let columns = [
        {
          data: function(row) {
            return row.std_account_movement_type.name;
          },
        },
        {
          data: function(row) {
            let ent_setup = enterprise_setup(vm);
            return filters.formatDate(
              row.create_date,
              ent_setup.simple_date_format,
            );
          },
        },
        {
          data: function(row) {
            return filters.formatCurrency(row.pending);
            // return row.pending;
          },
        },
        {
          data: function(row) {
            return filters.formatCurrency(row.pay);
          },
        },
      ];

      let onSelect = (data) => {
        vm.$alertify.prompt(
          vm.$t("enter payment amount"),
          data.amount - data.paid,
          function(evt, value) {
            if (value <= data.amount - data.paid) {
              data.pay = value;
              vm.refreshPendingMovements();
            } else return false;
          },
          function() {},
        );
      };
      let onCreatedRow = (row, data) => {
        if (data.pay == data.amount - data.paid)
          window.jQuery(row).addClass("positive");
        else if (data.pay < data.amount - data.paid && data.pay > 0)
          window.jQuery(row).addClass("warning");
      };

      init_json_local_data_datables(
        vm,
        vm.$refs.pending_movements_table,
        vm.pending_movements,
        columns,
        onSelect,
        onCreatedRow,
      );
    },
  },
  created() {
    let vm = this;
    if (vm.account_in) vm.account = vm.account_in;

    local_api(vm, "post", "/account_transaction_type/do-get-list", {})
      .then((types) => {
        vm.transaction_types = types.map((t) => {
          t.setup = JSON.parse(t.setup);
          return t;
        });

        window
          .jQuery(vm.$refs.types_dropdown)
          .dropdown("setup menu", {
            values: vm.transaction_types.map((p) => {
              return {
                name: p.name,
                value: p.type_id,
              };
            }),
          })
          .dropdown({
            onChange(value) {
              vm.transaction_type = value;
              vm.selected_transaction_type = vm.transaction_types.find(
                (n) => n.type_id == value,
              );

              setTimeout(() => {
                window.jQuery(vm.$refs.receipt_date).calendar({
                  type: "date",
                  onChange(value) {
                    vm.receipt.date = value;
                  },
                });
              }, 200);
            },
          });
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });

    local_api(vm, "post", "/student_account/do-get-configuration")
      .then((conf) => {
        try {
          let stp = JSON.parse(conf.setup);
          if (stp && stp.student_movement_policy) {
            if (stp.student_movement_policy == "manual") {
              vm.show_pending = true;
              if (vm.account && vm.account.uuid) {
                local_api(vm, "post", "/account_movement/do-get-pending", {
                  a: vm.account.uuid,
                })
                  .then((pend) => {
                    pend = pend
                      /*.filter((p) => {
                      return p.amount - p.paid > 0;
                    })*/
                      .map((p) => {
                        p.pay = 0;
                        p.pending = Number(p.amount) - Number(p.paid);
                        return p;
                      });
                    vm.pending_movements = pend;

                    vm.refreshPendingMovements();
                  })
                  .catch((err) => {
                    console.log(err);
                    vm.$alertify.error(stringify(err));
                  });
              }
            } else if (stp.student_movement_policy == "oldest") {
              console.log("process oldest first");
            }
          }
        } catch (error) {
          console.error(error);
        }
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });
  },
  mounted() {
    let vm = this;
    window.jQuery(vm.$refs.form).form({
      fields: {
        type: ["empty"],
        amount: ["empty", "number"],
      },
    });

    let onSearchResponse = (data) => {
      let rslt = [];
      data.map((r) => {
        rslt.push({
          title: r.name,
          description: r.number,
          account: r,
        });
      });
      return { results: rslt };
    };
    let onSearchSelect = (data) => {
      vm.account = data.account;
    };

    init_search(
      vm,
      this.$refs.account_search,
      "search account",
      onSearchResponse,
      onSearchSelect,
    );
  },
  watch: {},
};
</script>
